import { render, staticRenderFns } from "./menu-introd.vue?vue&type=template&id=40d49dda&scoped=true"
import script from "./menu-introd.vue?vue&type=script&lang=js"
export * from "./menu-introd.vue?vue&type=script&lang=js"
import style0 from "./menu-introd.vue?vue&type=style&index=0&id=40d49dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d49dda",
  null
  
)

export default component.exports